import * as React from 'react'
// export interface IconsProps { color?: string, icon: string, height?: number, width?: number, fill?: any, props?: any }



const svg = {
  back: (props) => {
    return (
      <svg
            height={props.height ? props.height : 16}
            width={props.width ? props.width : 20}
            viewBox='2 0 20 16'
            xmlns='http://www.w3.org/2000/svg'>
            <g id='back'>
              <polyline
                fill='none'
                stroke={props.color ? props.color : '#143756'}
                strokeLinecap='round'
                strokeMiterlimit='10'
                points='9.389,14.552 2.8,7.961 
              9.362,1.449 	'
              />
              <line
                fill='none'
                stroke={props.color ? props.color : '#143756'}
                strokeLinecap='round'
                strokeMiterlimit='10'
                x1='2.972'
                y1='8'
                x2='21.2'
                y2='8'
              />
            </g>
          </svg>
    )
  },
  houses: (props) => {
    return (
      <svg
        height={props.height ? props.height : 20}
        width={props.width ? props.width : 20}
        viewBox='0 0 500 500'
        xmlns='http://www.w3.org/2000/svg'>
          <g>
            <path fill={props.color ? props.color : '#fff'} d="M420.47,349.87v-72.982l-47.88-45.089L324.7,276.888v49.396c-1.409-0.219-2.829-0.445-4.244-0.65v-97.055l-76.951-72.477
              l-76.943,72.477v97.485c-1.633,0.241-3.279,0.47-4.892,0.721v-49.835l-47.885-45.102l-47.883,45.102v73.655
              c-37.307,12.993-59.001,25.33-59.687,25.727l4.892,8.396c0.802-0.465,30.189-17.148,79.56-31.974
              c7.187-2.153,14.808-4.266,22.816-6.291c12.967-3.273,26.961-6.308,41.897-8.848c2.08-0.351,4.18-0.689,6.29-1.021
              c1.618-0.259,3.248-0.5,4.892-0.742c2.339-0.353,4.693-0.691,7.08-1.013c41.142-5.56,88.4-7.093,139.739-0.343
              c2.354,0.305,4.703,0.617,7.075,0.97c1.415,0.198,2.835,0.419,4.244,0.645c2.093,0.317,4.188,0.635,6.288,0.988
              c14.451,2.402,29.193,5.47,44.183,9.307c7.451,1.905,14.963,3.995,22.524,6.286c30.486,9.237,61.884,21.699,93.868,38.128
              l4.437-8.638C470.403,369.026,445.172,358.401,420.47,349.87z M112.302,305.693h-10.323v-10.03h10.323V305.693z M112.302,291.069
              h-10.323v-10.047h10.323V291.069z M127.497,305.693h-10.321v-10.03h10.321V305.693z M127.497,291.069h-10.321v-10.047h10.321
              V291.069z M239.62,262.298h-12.96v-12.586h12.96V262.298z M239.62,243.938h-12.96v-12.597h12.96V243.938z M258.688,262.298h-12.953
              v-12.586h12.953V262.298z M258.688,243.938h-12.953v-12.597h12.953V243.938z M370.442,304.397h-10.331v-10.027h10.331V304.397z
              M370.442,289.774h-10.331v-10.041h10.331V289.774z M385.635,304.397h-10.324v-10.027h10.324V304.397z M385.635,289.774h-10.324
              v-10.041h10.324V289.774z"/>
            <polygon fill={props.color ? props.color : '#fff'} points="243.504,145.802 333.847,230.887 346.047,217.93 243.504,121.353 140.972,217.93 153.173,230.887 	"/>
            <polygon fill={props.color ? props.color : '#fff'} points="114.027,225.962 161.652,270.817 161.652,252.483 114.027,207.626 50.234,267.715 59.385,277.43 	"/>
            <polygon fill={props.color ? props.color : '#fff'} points="324.7,270.817 372.325,225.962 426.968,277.43 436.118,267.715 372.325,207.626 324.7,252.483 	"/>
          </g>
      </svg>
    )
  },
  houseNewTech: (props) => {
    return (
      <svg
        height={props.height ? props.height : 20}
        width={props.width ? props.width : 20}
        viewBox='0 0 512 512'
        xmlns='http://www.w3.org/2000/svg'>
  <path fill={props.color ? props.color : '#fff'} d="M474.069,261.669h28.847l-37.257-56.259h-208.88l-25.275-26.105L152.996,98.28l-59.52,61.494v-22.132H101v-18.912H47.882
	v18.912h8.342v60.566l-47.14,48.657l8.13,13.468h32.859v123.604H23.061v29.783h474.259v-29.783h-23.25V261.669z M183.779,298.409
	h-11.858v-34.537h-0.496v34.537h-11.553v-34.545h23.907V298.409z M153.14,174.572c9.155,0,16.561,7.414,16.561,16.569
	c0,9.143-7.406,16.557-16.561,16.557c-9.125,0-16.573-7.414-16.573-16.557C136.567,181.986,144.015,174.572,153.14,174.572z
	 M123.391,263.864h26.059v34.545h-12.612v-34.537h-0.496v34.537h-12.435v0.491h12.435v37.545h-12.951V263.864z M136.838,336.445
	V298.9h12.612v37.545H136.838z M159.872,298.9h11.553v37.545h-11.553V298.9z M171.921,336.445V298.9h11.858v37.545H171.921z
	 M311.644,345.588c0-4.551,3.686-8.245,8.235-8.245c4.563,0,8.236,3.694,8.236,8.245c0,4.541-3.674,8.235-8.236,8.235
	C315.329,353.823,311.644,350.129,311.644,345.588z M322.053,329.124c1.732-4.745,5.816-15.912,6.512-18.311
	c0.948-3.05,4.872-3.05,4.872-3.05h18.306h6.093h18.293c0,0,3.979,0,4.897,3.05c0.733,2.398,4.8,13.565,6.546,18.311H322.053z
	 M324.586,383.937c1.487-1.423,2.479-3.363,2.479-5.575v-9.913h55.482v9.913c0,2.212,0.974,4.152,2.457,5.575H324.586z
	 M389.715,353.823c-4.533,0-8.219-3.694-8.219-8.235c0-4.551,3.686-8.245,8.219-8.245c4.516,0,8.219,3.694,8.219,8.245
	C397.934,350.129,394.23,353.823,389.715,353.823z M454.505,383.937h-1.763v-32.655l-9.681-5.66l-9.329,5.66v32.655h-4.863v-32.655
	l-9.681-5.66l-9.329,5.66v32.655h-14.23c1.491-1.423,2.482-3.363,2.482-5.575v-9.913h8.66v-27.131c0-5.982-4.275-10.939-9.943-11.99
	l-8.164-20.039c0,0-1.542-8.837-12.536-9.143c-9.007,0-14.705,0-18.293,0c0,0-0.013,0-6.093,0c-3.571,0-9.257,0-18.306,0
	c-10.965,0.306-12.478,9.143-12.478,9.143l-8.163,20.039c-5.673,1.051-9.999,6.008-9.999,11.99v27.131h8.702v9.913
	c0,2.212,0.975,4.152,2.457,5.575h-14.438v-32.655l-9.686-5.66l-9.324,5.66v32.655h-3.542v-32.655l-9.697-5.66l-9.325,5.66v32.655
	h-1.576V261.669h198.136V383.937z"/>
      </svg>
    )
  },
  houseComplate: (props) => {
    return (
      <svg
        height={props.height ? props.height : 20}
        width={props.width ? props.width : 20}
        viewBox='0 0 512 512'
        xmlns='http://www.w3.org/2000/svg'>
        <g>
          <polygon fill={props.color ? props.color : '#fff'} points="495.821,172.003 181.339,335.633 8.331,274.273 181.339,376.545 	"/>
          <path fill={props.color ? props.color : '#fff'} d="M131.911,235.283v71.353l49.428,17.045l149.998-76.705v-9.992l-108.233-83.521L131.911,235.283z M222.184,269.372h-20.448
            v-20.458h20.448V269.372z M222.184,242.95h-20.448v-20.453h20.448V242.95z M229.491,222.496h20.451v20.453h-20.451V222.496z
            M229.491,248.913h20.451v20.453h-20.451V248.913z"/>
          <polygon fill={props.color ? props.color : '#fff'} points="131.936,357.713 131.911,396.574 331.337,396.574 331.338,289.357 181.339,386.918 	"/>
          <polygon fill={props.color ? props.color : '#fff'} points="223.104,140.68 339.005,232.72 359.841,230.596 373.653,222.659 304.709,166.382 317.699,176.983 317.699,138.125 
            292.917,138.125 292.917,156.757 225.891,102.045 223.104,99.773 78.22,229.31 122.532,229.31 	"/>
        </g>
      </svg>
    )
  },
  houseGround: (props) => {
    return (
      <svg
        height={props.height ? props.height : 20}
        width={props.width ? props.width : 20}
        viewBox='0 0 500 500'
        xmlns='http://www.w3.org/2000/svg'>
          <g>
          <path fill={props.color ? props.color : '#fff'} d="M492.367,225.353l-52.847-66.616l-15.547,15.102l50.796,64.645v96.365l-30.883-30.887l-91.698,1.03v-82.212l81.106-64.042
            L289.419,189.39L62.922,158.737l78.315,78.891v93.784H37.281V260.98l0.991-0.101l41.307-76.827l-22.655-21.978L7.632,263.994
            l20.989-2.133v69.551v9.852h8.66h103.955h30.668v-9.852V268.52l72.212,72.743h230.653h6.415v-94.617l11.183,14.232V225.353z
            M261.437,240.013l70.616-1.335l2.698-2.131v68.639l-9.369,0.105L261.437,240.013z"/>
          <rect fill={props.color ? props.color : '#fff'} x="394.663" y="253.335" width="14.652" height="15.652"/>
          <rect fill={props.color ? props.color : '#fff'} x="412.65" y="253.335" width="14.657" height="15.652"/>
          <rect fill={props.color ? props.color : '#fff'} x="394.663" y="234.682" width="14.652" height="15.655"/>
          <rect fill={props.color ? props.color : '#fff'} x="412.65" y="234.682" width="14.657" height="15.655"/>
          <rect fill={props.color ? props.color : '#fff'} x="74.473" y="260.165" width="14.654" height="15.652"/>
          <rect fill={props.color ? props.color : '#fff'} x="92.459" y="260.165" width="14.649" height="15.652"/>
          <rect fill={props.color ? props.color : '#fff'} x="74.473" y="241.509" width="14.654" height="15.658"/>
          <rect fill={props.color ? props.color : '#fff'} x="92.459" y="241.509" width="14.649" height="15.658"/>
        </g>
      </svg>
    )
  },
  rupee: (props) => {
    return (
      <svg
        height={props.height ? props.height : 9.6}
        width={props.width ? props.width : 5.9}
        viewBox='0 0 5.9 9.6'
        fill={props.color ? props.color :'#143756'}
        xmlns='http://www.w3.org/2000/svg'>
        <g>
          <path d='M2.5,9.6L0,5.3V4.4h0.6c0.6,0,1-0.1,1.4-0.3c0.3-0.2,0.6-0.5,0.6-1H0V2.2h2.6C2.5,1.8,2.3,1.5,2,1.3
          C1.7,1.1,1.3,0.9,0.8,0.9H0V0h5.9v0.9H3.6C4,1.3,4.2,1.7,4.3,2.2h1.6v0.9H4.3C4.2,3.8,4,4.4,3.5,4.7c-0.4,0.4-1,0.6-1.7,0.7
          l2.6,4.2H2.5z'/>
        </g>
      </svg>
    )
  },
  users: (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" 
        height={props.height ? props.height : 18}
        width={props.width ? props.width : 18}
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={props.color ? props.color :'#143756'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        className="feather feather-users">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
    )
  },
  info: (props) => {
    return (
      <svg
        height={props.height ? props.height : 18}
        width={props.width ? props.width : 18}
        viewBox='0 0 18 18'
        xmlns='http://www.w3.org/2000/svg'>
          <g>
            <circle fill='none' stroke={props.color ? props.color : '#F72D26'} strokeMiterlimit='10' cx='9' cy='9' r='6'/>
            <path fillRule='evenodd' clipRule='evenodd' fill={props.color ? props.color : '#F72D26'} d='M8.2,11.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.1,0.4-0.1
              c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2
              C8.3,11.9,8.2,11.7,8.2,11.5z M9.1,10.1H8.6L8.3,5.2h1L9.1,10.1z'/>
          </g>
      </svg>
    )
  },
  information: (props) => {
    return (
      <svg
        height={props.height ? props.height : 10}
        width={props.width ? props.width : 10}
        viewBox='0 0 100 100'
        xmlns='http://www.w3.org/2000/svg'>
         <path fill={ props.color || '#389bff'} d='M62.162,0c6.696,0,10.043,4.567,10.043,9.789c0,6.522-5.814,12.555-13.391,12.555
			c-6.344,0-10.045-3.752-9.869-9.947C48.945,7.176,53.35,0,62.162,0z M41.543,100c-5.287,0-9.164-3.262-5.463-17.615l6.07-25.457
			c1.057-4.077,1.23-5.707,0-5.707c-1.588,0-8.451,2.816-12.51,5.59L27,52.406C39.863,41.48,54.662,35.072,61.004,35.072
			c5.285,0,6.168,6.361,3.525,16.148L57.58,77.98c-1.234,4.729-0.703,6.359,0.527,6.359c1.586,0,6.787-1.963,11.896-6.041L73,82.377
			C60.488,95.1,46.83,100,41.543,100z'/>
      </svg>
    )
  },
  error: (props) => {
    return (
      <svg
        height={props.height ? props.height : 29}
        width={props.width ? props.width : 29}
        viewBox='0 0 29 29'
        xmlns='http://www.w3.org/2000/svg'>
         <g id='Elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g id='Notification-/-banner-/-Top-/-Error' transform='translate(-15.000000, -15.000000)'>
            <g id='Group' transform='translate(15.000000, 15.000000)'>
                <circle id='Oval' stroke={props.color ? props.color : '#F54B5E'} cx='14.5' cy='14.5' r='14' />
                <path d='M11,9.21220151 C11.1869164,9.04727531 11.3916967,8.89059777 11.614347,8.74216419 C11.8369974,8.59373061 12.0775112,8.46454036 12.3358955,8.35458956 C12.5942799,8.24463876 12.8746503,8.1580538 13.177015,8.09483209 C13.4793797,8.03161038 13.8064784,8 14.158321,8 C14.6366069,8 15.0722804,8.06596949 15.4653546,8.19791045 C15.8584287,8.32985141 16.1951479,8.51813933 16.4755225,8.76277986 C16.755897,9.00742039 16.9730466,9.30290874 17.1269777,9.64925376 C17.2809088,9.99559878 17.3578732,10.3831695 17.3578732,10.8119777 C17.3578732,11.2297907 17.2974012,11.5912485 17.1764553,11.896362 C17.0555095,12.2014755 16.902955,12.4667278 16.7187874,12.6921269 C16.5346198,12.9175261 16.335337,13.1126858 16.1209329,13.277612 C15.9065289,13.4425382 15.7031229,13.5978414 15.510709,13.7435262 C15.3182951,13.889211 15.151997,14.0321449 15.0118098,14.1723322 C14.8716225,14.3125195 14.7877863,14.4705714 14.7602986,14.6464927 L14.5706344,15.8504479 L13.177015,15.8504479 L13.0368284,14.5063061 C13.0313309,14.4788184 13.0285821,14.4554542 13.0285821,14.4362128 L13.0285821,14.3661195 C13.0285821,14.1242278 13.0890542,13.91395 13.21,13.7352799 C13.3309459,13.5566099 13.482126,13.3889374 13.6635448,13.2322576 C13.8449636,13.0755777 14.0401234,12.9230232 14.2490299,12.7745896 C14.4579364,12.6261561 14.6530962,12.4653554 14.834515,12.2921829 C15.0159338,12.1190104 15.1671139,11.9224763 15.2880598,11.7025747 C15.4090057,11.4826731 15.4694777,11.2242926 15.4694777,10.9274254 C15.4694777,10.729514 15.4323699,10.552221 15.3581531,10.3955411 C15.2839363,10.2388612 15.1808589,10.1041735 15.048918,9.99147391 C14.916977,9.87877434 14.7589251,9.79218939 14.5747575,9.73171645 C14.3905899,9.67124351 14.1913071,9.64100749 13.976903,9.64100749 C13.6635433,9.64100749 13.3982909,9.6753666 13.1811381,9.74408585 C12.9639853,9.8128051 12.7798204,9.88976951 12.6286381,9.97498138 C12.4774557,10.0601932 12.3496398,10.1371577 12.2451866,10.2058769 C12.1407333,10.2745962 12.0472765,10.3089553 11.9648134,10.3089553 C11.766902,10.3089553 11.6239681,10.2264934 11.5360075,10.0615672 L11,9.21220151 Z M12.5585448,18.9345524 C12.5585448,18.7641287 12.5901552,18.6019537 12.6533769,18.4480226 C12.7165986,18.2940914 12.8045579,18.1621525 12.9172575,18.0522017 C13.0299571,17.9422509 13.1632704,17.8542915 13.3172015,17.7883211 C13.4711327,17.7223506 13.6360564,17.6893658 13.8119777,17.6893658 C13.9824014,17.6893658 14.1445764,17.7223506 14.2985075,17.7883211 C14.4524386,17.8542915 14.5843776,17.9422509 14.6943284,18.0522017 C14.8042792,18.1621525 14.8922385,18.2940914 14.958209,18.4480226 C15.0241795,18.6019537 15.0571642,18.7641287 15.0571642,18.9345524 C15.0571642,19.1104737 15.0241795,19.2740231 14.958209,19.4252054 C14.8922385,19.5763878 14.8042792,19.7069524 14.6943284,19.8169032 C14.5843776,19.926854 14.4524386,20.0134389 14.2985075,20.0766607 C14.1445764,20.1398824 13.9824014,20.1714927 13.8119777,20.1714927 C13.6360564,20.1714927 13.4711327,20.1398824 13.3172015,20.0766607 C13.1632704,20.0134389 13.0299571,19.926854 12.9172575,19.8169032 C12.8045579,19.7069524 12.7165986,19.5763878 12.6533769,19.4252054 C12.5901552,19.2740231 12.5585448,19.1104737 12.5585448,18.9345524 L12.5585448,18.9345524 Z' id='?' fill='#F54B5E' />
            </g>
           </g>
        </g>
      </svg>
    )
  },
  warning: (props) => {
    return (
      <svg
        height={props.height ? props.height : 29}
        width={props.width ? props.width : 29}
        viewBox='0 0 29 29'
        xmlns='http://www.w3.org/2000/svg'>
        <g id='Elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g id='Notification-/-banner-/-Top-/-Warning' transform='translate(-15.000000, -15.000000)'>
              <g id='Icon-:-warnning' transform='translate(15.000000, 15.000000)'>
                  <circle id='Oval' stroke={props.color ? props.color : '#F8C51C'} cx='14.5' cy='14.5' r='14'/>
                  <path d='M15.32,7.986 L15.32,13.134 C15.32,13.6800027 15.2930003,14.2154974 15.239,14.7405 C15.1849997,15.2655026 15.1130005,15.8219971 15.023,16.41 L13.52,16.41 C13.4299996,15.8219971 13.3580003,15.2655026 13.304,14.7405 C13.2499997,14.2154974 13.223,13.6800027 13.223,13.134 L13.223,7.986 L15.32,7.986 Z M12.881,19.776 C12.881,19.5899991 12.9154997,19.4130008 12.9845,19.245 C13.0535003,19.0769992 13.1494994,18.9330006 13.2725,18.813 C13.3955006,18.6929994 13.5409992,18.5970004 13.709,18.525 C13.8770008,18.4529996 14.056999,18.417 14.249,18.417 C14.4350009,18.417 14.6119992,18.4529996 14.78,18.525 C14.9480008,18.5970004 15.0919994,18.6929994 15.212,18.813 C15.3320006,18.9330006 15.4279996,19.0769992 15.5,19.245 C15.5720004,19.4130008 15.608,19.5899991 15.608,19.776 C15.608,19.968001 15.5720004,20.1464992 15.5,20.3115 C15.4279996,20.4765008 15.3320006,20.6189994 15.212,20.739 C15.0919994,20.8590006 14.9480008,20.9534997 14.78,21.0225 C14.6119992,21.0915003 14.4350009,21.126 14.249,21.126 C14.056999,21.126 13.8770008,21.0915003 13.709,21.0225 C13.5409992,20.9534997 13.3955006,20.8590006 13.2725,20.739 C13.1494994,20.6189994 13.0535003,20.4765008 12.9845,20.3115 C12.9154997,20.1464992 12.881,19.968001 12.881,19.776 L12.881,19.776 Z' id='!' fill='#F8C51C' />
              </g>
          </g>
         </g>
      </svg>
    )
  },
  success: (props) => {
    return (
      <svg
        height={props.height ? props.height : 29}
        width={props.width ? props.width : 29}
        viewBox='0 0 29 29'
        xmlns='http://www.w3.org/2000/svg'>
          <g id='Elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
              <g id='Notification-/-banner-/-Top-/-Success' transform='translate(-15.000000, -15.000000)' stroke={props.color ? props.color : '#48D2A0'}>
                  <g id='Group' transform='translate(15.000000, 15.000000)'>
                      <g id='Icon-:-thick-check' transform='translate(9.000000, 11.000000)' strokeLinecap='round' strokeWidth='2'>
                          <path d='M0.139305389,3.97672227 L3.65542243,7.66864516' id='Stroke-23'/>
                          <path d='M11.0208295,0 L3.68663594,7.65651613' id='Stroke-25'/>
                      </g>
                      <circle id='Oval-Copy' cx='14.5' cy='14.5' r='14' />
                  </g>
              </g>
          </g>
      </svg>
    )
  },
  play: (props) => {
    return (
    <svg 
      x="0px" 
      y="0px" 
      height={props.height ? props.height : 25}
      width={props.width ? props.width : 25}
      viewBox='0 0 1000 1000'
      fill={props.color ? props.color : '#143756'}
      xmlSpace="preserve"
    >
      <g>
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
          <path d="M4526.2,5008.1c-1477.3-151.4-2791.8-942.7-3625.3-2186.3C594.3,2362,306.9,1678,197.7,1139.5C115.3,733.3,100,574.3,100,124c0-450.3,15.3-605.5,97.7-1015.5C305-1422.3,592.4-2108.3,900.9-2573.9c921.6-1377.7,2458.4-2207.3,4094.7-2207.3c1850.9,0,3556.3,1059.6,4386,2722.8c831.6,1668.9,653.4,3631-467.5,5123.7c-776,1034.7-1921.8,1714.9-3228.6,1916.1C5445.9,5017.7,4771.4,5035,4526.2,5008.1z M5380.8,4243.6c310.4-30.7,595.9-92,906.3-193.5c1247.4-408.1,2230.3-1393,2638.5-2642.3c484.8-1485,97.7-3100.3-1007.9-4205.8c-873.7-873.7-2100-1316.4-3316.8-1195.7C2627.3-3798.3,1073.4-2242.4,876-261.1c-130.3,1316.4,425.4,2682.6,1437.1,3533.3C3175.3,3996.5,4294.3,4350.9,5380.8,4243.6z"/><path d="M3754,2203c-42.2-19.2-74.7-53.7-99.6-109.2C3618,2013.3,3616,1952,3616,124c0-1829.9,1.9-1889.3,38.3-1969.7c49.8-109.2,143.7-153.3,260.6-122.6c113,30.7,3199.9,1831.8,3293.8,1923.8c69,67.1,76.7,82.4,76.7,168.6c0,86.2-7.7,101.6-76.7,168.6c-78.5,76.7-3140.5,1872-3265,1916.1C3861.3,2237.5,3832.6,2237.5,3754,2203z"/>
        </g>
      </g>
    </svg>
    )
  },
  home: (props) => {
    return (
      <svg
        height={props.height ? props.height : 16}
        width={props.width ? props.width : 16}
        viewBox='0 0 16 16'
        fill={props.color ? props.color : '#143756'}
        xmlns='http://www.w3.org/2000/svg'>
<path d='M13.5,6.8c0,0.1,0.1,8.3,0.1,8.3h-2.9v-4.9c0-0.3-0.2-0.5-0.5-0.5H5.8c-0.3,0-0.5,0.2-0.5,0.5v5H2.5V7.1L7.9,1L13.5,6.8z'/>
<path d='M15.7,8L8.4,0.3C8.3,0.3,8.2,0.2,8,0.2c-0.1,0-0.3,0.1-0.4,0.1L0.3,8c-0.2,0.2-0.2,0.5,0,0.7s0.5,0.2,0.7,0L1.7,8v7.3
	c0,0.3,0.2,0.5,0.5,0.5h3.4c0.3,0,0.5-0.2,0.5-0.5v-4.9H10v4.9c0,0.3,0.2,0.5,0.5,0.5h3.4c0.3,0,0.5-0.2,0.5-0.5V8L15,8.7
	c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1C15.8,8.5,15.9,8.2,15.7,8z M13.3,7.3v7.5h-2.4V10c0-0.3-0.2-0.5-0.5-0.5H5.6
	c-0.3,0-0.5,0.2-0.5,0.5v4.9H2.7V7L8,1.4L13.3,7.3z'/>
      </svg>
    )
  },
  transactions: (props) => {
    return (
      <svg
        height={props.height ? props.height : 16}
        width={props.width ? props.width : 16}
        viewBox='0 0 16 16'
        fill={props.color ? props.color : '#143756'}
        xmlns='http://www.w3.org/2000/svg'>
<path fillRule='evenodd' clipRule='evenodd' d='M9.7,7v7.5H0.8V3.2H6V7H9.7z'/>
<path fillRule='evenodd' clipRule='evenodd' d='M6.5,2.7H1.1c-0.6,0-1,0.4-1,0.9v10.7c0,0.5,0.4,0.9,1,0.9h8.4
	c0.6,0,1-0.4,1-0.9v-8L6.5,2.7z M6.5,3.9l2.5,2.3H6.5V3.9z M9.5,14.2H1.1V3.6h4.4v3.5h3.9V14.2z M12,0.9H6.5c-0.6,0-1,0.4-1,0.9H11
	v3.5h3.9v7.1h-3.4v0.9h3.4c0.6,0,1-0.4,1-0.9v-8L12,0.9z M12,4.5V2.1l2.5,2.3H12z'/>
      </svg>
    )
  },
  ledgers: (props) => {
    return (
      <svg
        height={props.height ? props.height : 16}
        width={props.width ? props.width : 16}
        viewBox='0 0 16 16'
        fill={props.color ? props.color : '#143756'}
        xmlns='http://www.w3.org/2000/svg'>
<path d='M15,4.8L8,8.6L0.9,4.8L8,1.2L15,4.8z'/>
<path fillRule='evenodd' clipRule='evenodd' d='M15.4,8.2c0,0.2-0.1,0.3-0.2,0.4l-7,3.8c-0.1,0-0.1,0.1-0.2,0.1
	c-0.1,0-0.2,0-0.2-0.1l-7-3.8C0.6,8.5,0.5,8.4,0.5,8.2c0-0.2,0.1-0.3,0.3-0.4L2.2,7l1,0.5L1.9,8.2l5.9,3.2l6-3.2l-1.2-0.6l1-0.5
	l1.4,0.7C15.3,7.9,15.4,8,15.4,8.2z M15.1,11.1l-1.3-0.6l-1,0.5l1.1,0.5l-6,3.2l-5.9-3.2L3.1,11l-1-0.5l-1.4,0.6
	c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.2,0.1,0.3,0.2,0.4l7,3.8c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l7-3.8c0.2-0.1,0.2-0.2,0.2-0.4
	C15.4,11.3,15.3,11.1,15.1,11.1z M16,4.7c0,0.4-0.2,0.7-0.5,0.9l-7,3.8C8.3,9.5,8.1,9.5,8,9.5s-0.3,0-0.5-0.1l-7-3.8
	C0.2,5.4,0,5.1,0,4.7c0-0.4,0.2-0.7,0.5-0.9l7-3.5c0.3-0.1,0.6-0.1,0.9,0l6.9,3.5C15.7,4.1,16,4.4,16,4.7z M14.9,4.8L8,1.3L1,4.8
	l7,3.7L14.9,4.8z'/>
     </svg>
    )
  },
  inventory: (props) => {
    return (
      <svg
        height={props.height ? props.height : 16}
        width={props.width ? props.width : 16}
        viewBox='0 0 16 16'
        fill={props.color ? props.color : '#143756'}
        xmlns='http://www.w3.org/2000/svg'>
<path d='M15.7,4.3C15.7,4.3,15.7,4.2,15.7,4.3L9.3,0.2C9.2,0.1,9.1,0.1,8.9,0.1L0.5,2.3C0.3,2.3,0.2,2.5,0.1,2.7c0,0,0,0.1,0,0.1
	l0,7.8c0,0.1,0.1,0.3,0.2,0.4l5.6,4.8c0,0,0,0,0.1,0c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0l9.1-2.8c0.2-0.1,0.3-0.2,0.3-0.5
	l0-7.9C15.9,4.5,15.8,4.4,15.7,4.3z M9,1.1l5.2,3.3l-3.2,0.8L6.4,1.8L9,1.1z M5.7,14.3l-4.6-4l0-6.6l4.6,3.5V14.3z M6.3,6.4L2.6,3.7
	L1.7,3l3.4-0.9l4.5,3.5L6.3,6.4z M14.9,12.2l-8.1,2.5V7.4l8.2-2.1L14.9,12.2z'/>
<path d='M15.1,5.1l0,7.2l-8.5,2.6V7.3L15.1,5.1z'/>
  </svg>
    )
  },
  form: (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" 
      height={props.height ? props.height : 14}
      width={props.width ? props.width : 14}
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={props.color || "currentColor"} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className="feather feather-file-text">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
    )
  },
  edit: (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" 
      height={props.height ? props.height : 14}
      width={props.width ? props.width : 14}
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={props.color || "currentColor"}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        className="feather feather-edit">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
    )
  },
  reports: (props) => {
    return (
      <svg
        height={props.height ? props.height : 16}
        width={props.width ? props.width : 16}
        viewBox='0 0 16 16'
        fill={props.color ? props.color : '#143756'}
        xmlns='http://www.w3.org/2000/svg'>
<g>
	<path style={{opacity:0.8}} d='M11.5,14.4C11.5,14.4,11.5,14.4,11.5,14.4c-0.2,0-0.4-0.2-0.5-0.4L8.6,5.5l-2.7,5.7
		c-0.1,0.2-0.3,0.3-0.4,0.3c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.4-0.3L3.3,7.8l-2.4,2.4c-0.2,0.2-0.5,0.2-0.7,0S0,9.6,0.2,9.4L3,6.6
		c0.1-0.1,0.3-0.2,0.4-0.1c0.2,0,0.3,0.1,0.4,0.3l1.6,3.1l2.9-6c0.1-0.2,0.3-0.3,0.5-0.3C9,3.6,9.2,3.8,9.2,4l2.3,8.2L15,1.9
		c0.1-0.3,0.4-0.4,0.6-0.3C15.9,1.7,16,2,15.9,2.2L12,14.1C11.9,14.3,11.7,14.4,11.5,14.4z'/>
</g>
  </svg>
    )
  },
  search: (props) => {
    return (
      <svg
        height={props.height ? props.height : 16}
        width={props.width ? props.width : 16}
        viewBox='0 0 16 16'
        fill={props.color ? props.color : 'rgba(20, 55, 86, 0.24)'}
        xmlns='http://www.w3.org/2000/svg'>
    <path d='M14.9,14.2L10.8,10C11.6,9,12,7.7,12,6.5c0-3.1-2.5-5.6-5.5-5.6S0.9,3.4,0.9,6.5S3.4,12,6.5,12c1.3,0,2.6-0.5,3.6-1.3
	l4.2,4.2c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2C15.2,14.7,15.2,14.4,14.9,14.2z M6.5,11C4,11,2,9,2,6.5C2,4,4,2,6.5,2
	c2.5,0,4.5,2,4.5,4.5C10.9,9,8.9,11,6.5,11z'/>
  </svg>
    )
  },
  logout: (props) => {
    return (
      <svg
        height={props.height ? props.height : 20}
        width={props.width ? props.width : 20}
        viewBox='0 0 512 512'
        fill={props.color ? props.color : 'rgba(20, 55, 86, 0.24)'}
        xmlns='http://www.w3.org/2000/svg'>
        <g>
        <g>
          <path d="M505.664,243.739l-54.783-38.622c-9.926-6.997-23.645,0.128-23.645,12.26v23.622H164.196
            c-8.284,0-15.001,6.716-15.001,15.001S155.912,271,164.196,271h263.038v23.621c0,12.212,13.792,19.204,23.644,12.26l54.783-38.622
            C514.027,262.365,514.196,249.767,505.664,243.739z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M430.471,352.317c-7.169-4.146-16.347-1.698-20.496,5.474c-35.236,60.916-101.103,101.811-176.372,101.811
            c-112.266,0-203.602-91.336-203.602-203.602S121.337,52.398,233.603,52.398c75.319,0,141.156,40.933,176.371,101.809
            c4.148,7.172,13.328,9.619,20.496,5.474c7.171-4.148,9.621-13.325,5.474-20.496C395.418,69.127,319.729,22.397,233.603,22.397
            C104.49,22.397,0,126.876,0,256c0,129.113,104.479,233.603,233.603,233.603c86.163,0,161.833-46.763,202.342-116.79
            C440.092,365.642,437.642,356.466,430.471,352.317z"/>
        </g>
      </g>
  </svg>
    )
  },
  setting: (props) => {
    return (
      <svg version='1.1' 
      xmlns='http://www.w3.org/2000/svg' 
      x='0px' y='0px' 
      viewBox='0 0 340.274 340.274' 
      height={props.height ? props.height : 16}
      width={props.width ? props.width : 16}
      fill={props.color ? props.color : '#143756'}
      >
     <g>
      <g>
        <g>
          <path d='M293.629,127.806l-5.795-13.739c19.846-44.856,18.53-46.189,14.676-50.08l-25.353-24.77l-2.516-2.12h-2.937
            c-1.549,0-6.173,0-44.712,17.48l-14.184-5.719c-18.332-45.444-20.212-45.444-25.58-45.444h-35.765
            c-5.362,0-7.446-0.006-24.448,45.606l-14.123,5.734C86.848,43.757,71.574,38.19,67.452,38.19l-3.381,0.105L36.801,65.032
            c-4.138,3.891-5.582,5.263,15.402,49.425l-5.774,13.691C0,146.097,0,147.838,0,153.33v35.068c0,5.501,0,7.44,46.585,24.127
            l5.773,13.667c-19.843,44.832-18.51,46.178-14.655,50.032l25.353,24.8l2.522,2.168h2.951c1.525,0,6.092,0,44.685-17.516
            l14.159,5.758c18.335,45.438,20.218,45.427,25.598,45.427h35.771c5.47,0,7.41,0,24.463-45.589l14.195-5.74
            c26.014,11,41.253,16.585,45.349,16.585l3.404-0.096l27.479-26.901c3.909-3.945,5.278-5.309-15.589-49.288l5.734-13.702
            c46.496-17.967,46.496-19.853,46.496-25.221v-35.029C340.268,146.361,340.268,144.434,293.629,127.806z M170.128,228.474
            c-32.798,0-59.504-26.187-59.504-58.364c0-32.153,26.707-58.315,59.504-58.315c32.78,0,59.43,26.168,59.43,58.315
            C229.552,202.287,202.902,228.474,170.128,228.474z'/>
        </g>
      </g>
    </g>
      </svg>
    )
  },
  backArrow: (props) => {
    return (
      <svg
        height={props.height ? props.height : 11}
        width={props.width ? props.width : 6}
        viewBox='0 0 6 11'
        xmlns='http://www.w3.org/2000/svg'>
    <path fill={props.color ? props.color : '#143756'} fillRule='evenodd' d='M4.43 10.03L0 5.134 4.43.236a.713.713 0 0 1 1.06 0 .852.852 0 0 1 0 1.143L2.005 5.134l3.487 3.754a.851.851 0 0 1 0 1.142.722.722 0 0 1-.53.237.722.722 0 0 1-.53-.237z'/>
  </svg>
    )
  },
  leftArrow: (props) => {
    return (
      <svg
        height={props.height ? props.height : 24}
        width={props.width ? props.width : 24}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'>
        <path fill={props.color ? props.color : '#143756'} d='M16.5,18.4l-9.5-6c-0.3-0.2-0.3-0.6,0-0.8l9.5-6c0.3-0.2,0.7,0,0.7,0.4l0,12C17.2,18.4,16.8,18.6,16.5,18.4z
	'/>
  </svg>
    )
  },
  rightArrow: (props) => {
    return (
      <svg
        height={props.height ? props.height : 24}
        width={props.width ? props.width : 24}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'>
        <path  fill={props.color ? props.color : '#143756'}  d='M6.8,18V6c0-0.4,0.4-0.6,0.7-0.4l9.5,6c0.3,0.2,0.3,0.6,0,0.8l-9.5,6C7.2,18.6,6.8,18.4,6.8,18z'/>
  </svg>
    )
  },
  cross: (props) => {
    return (
      <svg height={props.height ? props.height : 24}
      width={props.width ? props.width : 24} fill={props.color ? props.color : '#143756'} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/><path d='M0 0h24v24H0z' fill='none'/></svg>
    )
  },

  calendar: (props) => {
    return (
      <svg
        height={props.height ? props.height : 24}
        width={props.width ? props.width : 24}
        style={{minWidth: props.width ? props.width : 24}}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'>
        <path fill={props.color ? props.color : '#143756'} d='M4,9v10h16V9H4z M7.5,14C6.7,14,6,13.3,6,12.5S6.7,11,7.5,11S9,11.7,9,12.5S8.3,14,7.5,14z M19,5h-1
	c0-0.6-0.4-1-1-1s-1,0.4-1,1H8c0-0.6-0.4-1-1-1S6,4.4,6,5H5C3.9,5,3,5.9,3,7v11c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V7
	C21,5.9,20.1,5,19,5z M20,18c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1V9h16V18z M20,8H4V7c0-0.6,0.5-1,1-1h14c0.6,0,1,0.4,1,1V8z'/>
  </svg>
    )
  },

  loader: (props) => {
    return (
      <svg
        height={props.height ? props.height : 70}
        width={props.width ? props.width : 70}
        viewBox='0 0 100 100'
        xmlns='http://www.w3.org/2000/svg'>
        <circle cx="50" cy="50" r="32" strokeWidth="8" stroke="#fd7e15" strokeDasharray="50.26548245743669 50.26548245743669" fill="none" strokeLinecap="round" transform="rotate(136.934 50 50)">
  <animateTransform attributeName="transform" type="rotate" dur="3.125s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
</circle>
<circle cx="50" cy="50" r="23" strokeWidth="8" stroke="#090562" strokeDasharray="36.12831551628262 36.12831551628262" strokeDashoffset="36.12831551628262" fill="none" strokeLinecap="round" transform="rotate(-136.934 50 50)">
  <animateTransform attributeName="transform" type="rotate" dur="3.125s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;-360 50 50"></animateTransform>
</circle>
  </svg>
    )
  },

  refresh: (props) => {
    return (
      <svg
        height={props.height ? props.height : 70}
        width={props.width ? props.width : 70}
        viewBox='0 0 487.23 487.23'
        xmlns='http://www.w3.org/2000/svg'
        >
<g>
	<g>
		<path d="M55.323,203.641c15.664,0,29.813-9.405,35.872-23.854c25.017-59.604,83.842-101.61,152.42-101.61
			c37.797,0,72.449,12.955,100.23,34.442l-21.775,3.371c-7.438,1.153-13.224,7.054-14.232,14.512
			c-1.01,7.454,3.008,14.686,9.867,17.768l119.746,53.872c5.249,2.357,11.33,1.904,16.168-1.205
			c4.83-3.114,7.764-8.458,7.796-14.208l0.621-131.943c0.042-7.506-4.851-14.144-12.024-16.332
			c-7.185-2.188-14.947,0.589-19.104,6.837l-16.505,24.805C370.398,26.778,310.1,0,243.615,0C142.806,0,56.133,61.562,19.167,149.06
			c-5.134,12.128-3.84,26.015,3.429,36.987C29.865,197.023,42.152,203.641,55.323,203.641z"/>
		<path d="M464.635,301.184c-7.27-10.977-19.558-17.594-32.728-17.594c-15.664,0-29.813,9.405-35.872,23.854
			c-25.018,59.604-83.843,101.61-152.42,101.61c-37.798,0-72.45-12.955-100.232-34.442l21.776-3.369
			c7.437-1.153,13.223-7.055,14.233-14.514c1.009-7.453-3.008-14.686-9.867-17.768L49.779,285.089
			c-5.25-2.356-11.33-1.905-16.169,1.205c-4.829,3.114-7.764,8.458-7.795,14.207l-0.622,131.943
			c-0.042,7.506,4.85,14.144,12.024,16.332c7.185,2.188,14.948-0.59,19.104-6.839l16.505-24.805
			c44.004,43.32,104.303,70.098,170.788,70.098c100.811,0,187.481-61.561,224.446-149.059
			C473.197,326.043,471.903,312.157,464.635,301.184z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>


  </svg>
    )
  },

  map: (props) => {
    return (
      <svg
        height={props.height ? props.height : 13}
        width={props.width ? props.width : 8}
        viewBox='0 0 8 13'
        xmlns='http://www.w3.org/2000/svg'>
          <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
              <g id='Report' transform='translate(-64.000000, -74.000000)' fill={props.color ? props.color : '#F5A623'}  fillRule='nonzero'>
                  <path d='M67.8471274,86.2302797 C67.8805578,86.2823077 67.9381547,86.313761 67.9999973,86.313761 C68.0618399,86.313761 68.1194367,86.2823077 68.1528672,86.2302797 C68.754534,85.3002499 70.9637832,81.8119524 71.7280464,79.5786709 C71.9076247,79.0716957 71.9995895,78.5378498 72,78.0000096 C71.9997739,75.9512658 70.4520292,74.2336859 68.4143636,74.0209183 C68.1388234,73.9930272 67.8611711,73.9930272 67.5856309,74.0209183 C65.5479675,74.2336885 64.0002259,75.9512677 64,78.0000096 C64.0004105,78.5378498 64.0923753,79.0716957 64.2719536,79.5786709 C65.0362114,81.8119524 67.2454605,85.3002499 67.8471274,86.2302797 Z M67.9999891,75.9316408 C68.8365686,75.9316419 69.5907724,76.4355864 69.9109162,77.2084857 C70.2310601,77.9813849 70.0540971,78.8710295 69.4625449,79.4625794 C68.8709926,80.0541293 67.9813473,80.2310887 67.2084493,79.9109418 C66.4355514,79.5907949 65.9316099,78.8365891 65.9316121,78.0000096 C65.931611,77.4514423 66.1495286,76.9253428 66.537425,76.5374479 C66.9253214,76.149553 67.4514218,75.9316376 67.9999891,75.9316408 Z' id='Shape'/>
              </g>
          </g>
      </svg>
    )
  },
  externalLink: (props) => {
    return (
      <svg
        height={props.height ? props.height : 15}
        width={props.width ? props.width : 15}
        viewBox='0 0 243 243'
        xmlns='http://www.w3.org/2000/svg'>
              <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g id='Group-4' transform='translate(0.000000, -0.000000)' fill={props.color || '#389bff'}>
                    <path d='M140.5,19 L24,19 L24,221 L224,221 L224,102.5 L243,121.5 L243,220 C243,232.702549 232.702549,243 220,243 L23,243 C10.2974508,243 1.55561363e-15,232.702549 0,220 L0,23 C-1.55561363e-15,10.2974508 10.2974508,2.33342044e-15 23,0 L121.5,0 L140.5,19 Z' id='Combined-Shape'/>
                    <g id='Group-3' transform='translate(108.000000, 0.000000)'>
                        <polygon id='Rectangle' transform='translate(87.964466, 46.500000) rotate(-270.000000) translate(-87.964466, -46.500000) ' points='41.4644661 0 134.464466 0 41.4644661 93'/>
                        <rect id='Rectangle' transform='translate(49.000000, 82.464466) rotate(-315.000000) translate(-49.000000, -82.464466) ' x='35' y='27.4644661' width='28' height='110'/>
                    </g>
                </g>
            </g>
      </svg>
    )
  },
  video: (props) => {
    return (
      <svg
        height={props.height ? props.height : 20}
        width={props.width ? props.width : 20}
        viewBox='0 0 612 612'
        xmlns='http://www.w3.org/2000/svg'>
        <g>
        <g id="_x33__8_">
          <g>
            <path d="M573.75,267.75L459,344.25c0-23.218-10.557-43.758-26.89-57.796c38.881-23.428,65.14-65.637,65.14-114.329
              c0-73.938-59.938-133.875-133.875-133.875c-73.937,0-133.875,59.938-133.875,133.875c0,37.504,15.51,71.317,40.373,95.625
              h-70.151c18.322-20.33,29.778-46.971,29.778-76.5c0-63.38-51.37-114.75-114.75-114.75S0,127.87,0,191.25
              c0,34.578,15.625,65.216,39.818,86.254C16.199,290.528,0,315.371,0,344.25v153c0,42.247,34.253,76.5,76.5,76.5h306
              c42.247,0,76.5-34.253,76.5-76.5v-19.125l114.75,95.625c21.133,0,38.25-17.117,38.25-38.25V306
              C612,284.867,594.883,267.75,573.75,267.75z M38.25,191.25c0-42.247,34.253-76.5,76.5-76.5s76.5,34.253,76.5,76.5
              s-34.253,76.5-76.5,76.5S38.25,233.497,38.25,191.25z M420.75,497.25c0,21.114-17.117,38.25-38.25,38.25h-306
              c-21.133,0-38.25-17.117-38.25-38.25v-153c0-21.133,17.117-38.25,38.25-38.25h306c21.133,0,38.25,17.117,38.25,38.25V497.25z
               M363.375,267.96c-52.938,0-95.835-42.917-95.835-95.835c0-52.938,42.917-95.835,95.835-95.835s95.835,42.897,95.835,95.835
              S416.312,267.96,363.375,267.96z M573.75,535.5L459,439.875V382.5L573.75,306V535.5z"/>
          </g>
        </g>
      </g>
      </svg>
    )
  },
  audio: (props) => {
    return (
      <svg
        height={props.height ? props.height : 20}
        width={props.width ? props.width : 20}
        viewBox='0 0 611.964 611.964'
        xmlns='http://www.w3.org/2000/svg'>
        <g>
        <g>
          <path d="M284.554,64.019c-8.261-3.391-17.856-1.479-24.26,4.924L125.881,204.276H22.24C9.938,204.276,0,214.232,0,226.534v160.584
            c0,12.302,9.938,22.24,22.24,22.24h103.01l135.134,135.297c4.256,4.292,9.92,6.565,15.728,6.565c2.868,0,5.736-0.56,8.532-1.714
            c8.297-3.409,13.726-11.562,13.726-20.544l-0.036-444.345C298.334,75.581,292.887,67.5,284.554,64.019z M150.286,371.39
            c-4.167-4.167-9.867-6.512-15.765-6.512H44.498V248.792h90.619c5.952,0,11.616-2.345,15.783-6.566l102.938-103.641l0.036,336.627
            L150.286,371.39z"/>
          <path d="M516.15,306.222c0-83.386-49.584-158.51-126.368-191.356c-11.165-4.87-24.332,0.343-29.184,11.652
            c-4.816,11.291,0.433,24.368,11.724,29.202c60.316,25.901,99.331,84.937,99.331,150.52c0,65.222-38.798,124.096-98.826,149.996
            c-11.291,4.87-16.504,17.983-11.651,29.238c3.644,8.424,11.814,13.42,20.418,13.42c2.958,0,5.916-0.559,8.784-1.84
            C466.783,464.172,516.15,389.21,516.15,306.222z"/>
          <path d="M417.632,306.131c0-44.065-26.189-83.602-66.684-100.81c-11.291-4.689-24.35,0.487-29.202,11.814
            c-4.779,11.291,0.523,24.332,11.814,29.166c24.08,10.209,39.573,33.675,39.573,59.829c0,25.847-15.386,49.277-39.194,59.612
            c-11.255,4.87-16.468,18.001-11.508,29.238c3.644,8.388,11.814,13.384,20.418,13.384c2.958,0,5.916-0.56,8.82-1.857
            C391.748,389.121,417.632,349.709,417.632,306.131z"/>
          <path d="M427.643,26.79c-11.255-4.906-24.368,0.397-29.238,11.688c-4.816,11.292,0.415,24.333,11.67,29.202
            c95.651,41.017,157.41,134.647,157.41,238.542c0,103.587-61.597,197.001-156.851,238.108
            c-11.292,4.889-16.504,17.965-11.652,29.202c3.644,8.441,11.814,13.474,20.437,13.474c2.939,0,5.897-0.613,8.766-1.821
            c111.668-48.159,183.78-157.645,183.78-278.962C612,184.507,539.617,74.805,427.643,26.79z"/>
        </g>
      </g>
      </svg>
    )
  },
  image: (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" 
        height={props.height ? props.height : 24}
        width={props.width ? props.width : 24}
        viewBox="0 0 24 24" 
        fill="none" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        stroke={props.color ? props.color : '#4192ec'}
        className="feather feather-image">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <circle cx="8.5" cy="8.5" r="1.5"></circle>
        <polyline points="21 15 16 10 5 21"></polyline>
      </svg>
    )
  },
  eye: (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" 
        height={props.height ? props.height : 24}
        width={props.width ? props.width : 24}
        viewBox="0 0 24 24" 
        fill="none" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        stroke={props.color ? props.color : '#000'}
        className="feather feather-image">
         <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
      </svg>
    )
  },
  eyeoff: (props) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" 
        height={props.height ? props.height : 24}
        width={props.width ? props.width : 24}
        viewBox="0 0 24 24" 
        fill="none" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        stroke={props.color ? props.color : '#000'}
        className="feather feather-image">
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
  <line x1="1" y1="1" x2="23" y2="23"></line>
      </svg>
    )
  },
  delete: (props) => {
    return (
      <svg
        height={props.height ? props.height : 14}
        width={props.width ? props.width : 14}
        viewBox='0 0 12 12'
        xmlns='http://www.w3.org/2000/svg'>
        <g>
          <polyline
            fill='none'
            stroke={props.color ? props.color : '#4192ec'}
            strokeLinejoin='round'
            strokeMiterlimit='10'
            points='2.591,2.927 2.591,11.107 
          9.408,11.107 9.408,2.91 	'
          />
          <g>
            <line
              fill='none'
              stroke={props.color ? props.color : '#4192ec'}
              strokeLinecap='round'
              strokeMiterlimit='10'
              x1='4.938'
              y1='5.109'
              x2='4.938'
              y2='8.671'
            />
            <line
              fill='none'
              stroke={props.color ? props.color : '#4192ec'}
              strokeLinecap='round'
              strokeMiterlimit='10'
              x1='7.062'
              y1='5.083'
              x2='7.062'
              y2='8.646'
            />
          </g>

          <line
            fill='none'
            stroke={props.color ? props.color : '#4192ec'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            x1='0.601'
            y1='2.896'
            x2='11.4'
            y2='2.896'
          />
          <polyline
            fill='none'
            stroke={props.color ? props.color : '#4192ec'}
            strokeLinejoin='round'
            strokeMiterlimit='10'
            points='3.588,2.515 3.588,0.892 
          8.411,0.892 8.411,2.515 	'
          />
        </g>
      </svg>
    )
  },
}

class Icon extends React.Component {
   render() {
    return svg[this.props.icon](this.props)
  }
}

export { Icon }